export const NO_PREPARERS_ASSIGNED = 'No Preparers Assigned';
export const NO_REVIEWERS_ASSIGNED = 'No Reviewers Assigned';
export const STANDALONE_COMPANIES_FIRM_ID = 464;
export const STATUS_CHIP_COLOR = 'rgba(0, 0, 0, 0.87)';